import React, { useState } from 'react';
import { CaretDownOutline } from 'react-ionicons';
import { useAppSelector } from 'src/app/services/store';
import { getCurrentChild, isTimelineFilterApplied, getShowDownloadAppBanner, getTimelineFilters, getTimelineData } from 'src/shared/redux-state/src';
import { FilterIcon } from 'src/app/static/images/svg';
import { AppRoutes } from 'src/app/navigation/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import ProfileImageView from '../ProfileImageView';
import { ChildrenListModal, TimelineFilterModal } from '../../modals';
import NotificationBell from '../NotificationBell';
import DownloadAppBanner from '../DownloadAppBanner';
import CustomButton from '../CustomButton';
import { PiPrinterFill } from 'react-icons/pi';
import { TimelineData, TimelineStateType } from 'src/shared/types/src';

type IProps = {
  showLearningJourneyIcon?: boolean
}

const Header: React.FC<IProps> = ({showLearningJourneyIcon = false}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentChild = useAppSelector(getCurrentChild);
  const timelineFilterApplied = useAppSelector(isTimelineFilterApplied);
  const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);

  const [isChildrenListModal, setIsChildrenListModal] = useState<boolean>(false);
  const [isTimelineFilterModal, setIsTimelineFilterModal] = useState<boolean>(false);
  const timelineFilters: TimelineStateType['filters'] = useAppSelector(getTimelineFilters);
  const timelineData: TimelineData[] = useAppSelector(getTimelineData);

  const toggleChildrenListModal = () => {
    setIsChildrenListModal(!isChildrenListModal);
  }
  const toggleTimelineFilterModal = () => {
    setIsTimelineFilterModal(!isTimelineFilterModal);
  }

  const handlelearningJourneyClick = () => {
    const qstr = new URLSearchParams({
      ...(timelineFilters?.from && {from: timelineFilters?.from}),
      ...(timelineFilters?.to && {to: timelineFilters?.to})
    }).toString()
    console.log('url =' ,`${AppRoutes.LEARNING_JOURNEY_PRINT}${qstr ? `?${qstr}`: ''}`);
    const url = `${AppRoutes.LEARNING_JOURNEY_PRINT}${qstr ? `?${qstr}` : ''}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  return (
    <>
      <div className={`header ${showDownloadAppBanner ? 'h-auto' : ''}`}>
        {showDownloadAppBanner ? <DownloadAppBanner /> : null}
        <div className='container h-100'>
          <div className='row align-items-center h-100'>
            <div className='col-8'>
              <div className='d-flex align-items-center'>
                <ProfileImageView
                  name={currentChild?.name}
                  // imageUrl={'https://img.freepik.com/free-photo/view-child-hair-salon_23-2150462483.jpg'}
                  imageUrl={currentChild?.photo}
                />
                <div className='avatar-details avatar-details-w32'>
                  <p onClick={toggleChildrenListModal} className='avatar-name mb-0 text-black d-flex cursor-pointer'>
                    <span className='text-ellipsis fs-6 fw-semibold d-inline-block me-1'>
                      {currentChild?.name}
                    </span>
                    <CaretDownOutline
                      color={'#000000'}
                      height="12px"
                      width="12px"
                    />
                  </p>
                  <span className='avatar-nursery text-ellipsis fs-12 text-black d-block'>
                    {currentChild?.nursery?.name}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex align-items-center justify-content-end mx-n-8">
                {location.pathname.includes(AppRoutes.TIMELINE) ? (
                  <>
                    {showLearningJourneyIcon && (
                      <div className="px-2">
                        <CustomButton
                          icon={<PiPrinterFill size={22} />}
                          color="link"
                          disabled={!timelineData?.length}
                          onClick={handlelearningJourneyClick}
                          title={
                            timelineData?.length
                              ? `Print “My Learning Journey”`
                              : "No observation to print"
                          }
                          customBtnStyle="custom-btn-icon"
                          style={{pointerEvents: 'visible', opacity: timelineData?.length ? 1 :  0.7}}
                        />
                      </div>
                    )}
                    <div className="px-2">
                      <div className="d-flex position-relative cursor-pointer">
                        <span onClick={toggleTimelineFilterModal}>
                          <FilterIcon />
                        </span>
                        {timelineFilterApplied ? (
                          <span className="filter-badge"></span>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : null}
                <NotificationBell />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isChildrenListModal && <ChildrenListModal
        isChildrenListModal={isChildrenListModal}
        toggleChildrenListModal={toggleChildrenListModal}
      />}

      {isTimelineFilterModal && <TimelineFilterModal
        isTimelineFilterModal={isTimelineFilterModal}
        toggleTimelineFilterModal={toggleTimelineFilterModal}
      />}
    </>
  );
};

export default Header;
